export function formDataToObject(formData) {
    const object = {};

    function setNestedValue(obj, keys, value) {
        const currentKey = keys[0];

        // Base case: when we reach the last key
        if (keys.length === 1) {
            // Handle array indices
            if (!isNaN(currentKey)) {
                if (!Array.isArray(obj)) {
                    obj.length = 0;
                }
                obj[parseInt(currentKey)] = value;
            } else {
                obj[currentKey] = value;
            }
            return;
        }

        const nextKey = keys[1];
        const isArray = !isNaN(nextKey);

        // Create nested object/array if it doesn't exist
        if (!(currentKey in obj)) {
            obj[currentKey] = isArray ? [] : {};
        }

        // Recursive call with remaining keys
        setNestedValue(obj[currentKey], keys.slice(1), value);
    }

    for (const [key, value] of formData.entries()) {
        // Handle nested keys using dot or bracket notation
        const keys = key.match(/[^\[\]\.]+/g) || [key];
        setNestedValue(object, keys, value);
    }

    return object;
}

export function objectToFormData(obj, parentKey = '') {
    const formData = new FormData();

    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const fieldName = parentKey ? `${parentKey}[${key}]` : key;

            if (value === null || value === undefined) {
                continue;
            } else if (typeof value === 'object' && !(value instanceof File || value instanceof Blob)) {
                if (Array.isArray(value)) {
                    value.forEach((item, index) => {
                        if (item instanceof File || item instanceof Blob) {
                            formData.append(`${fieldName}[${index}]`, item);
                        } else if (typeof item === 'object') {
                            objectToFormData(item, `${fieldName}[${index}]`).forEach((value, key) => {
                                formData.append(key, value);
                            });
                        } else {
                            formData.append(`${fieldName}[${index}]`, item);
                        }
                    });
                } else {
                    objectToFormData(value, fieldName).forEach((value, key) => {
                        formData.append(key, value);
                    });
                }
            } else {
                formData.append(fieldName, value);
            }
        }
    }

    return formData;
}